import React, { useEffect } from "react";
import Image from "../pics";
import { Link } from "react-router-dom";

function Footer() {
  useEffect(() => {
    // Disable right-click context menu
    const disableContextMenu = (event) => {
      event.preventDefault();
    };

    // Disable specific keyboard shortcuts
    const disableShortcuts = (event) => {
      // F12 key
      if (event.key === "F12") {
        event.preventDefault();
      }
      // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U, Ctrl+S
      if (
        (event.ctrlKey && event.shiftKey && (event.key === "I" || event.key === "J")) ||
        (event.ctrlKey && (event.key === "U" || event.key === "S"))
      ) {
        event.preventDefault();
      }
    };

    // Attach event listeners
    document.addEventListener("contextmenu", disableContextMenu);
    document.addEventListener("keydown", disableShortcuts);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
      document.removeEventListener("keydown", disableShortcuts);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <div>
      <div className="uk-section uk-padding-remove-bottom" style={{
        background: 'linear-gradient(135deg, rgba(200,16,46,1) 60%, rgba(255,25,62,1) 100%)'
      }}>
        <div className="uk-container">
          <div className="uk-grid-match" data-uk-grid>
            <div className="uk-width-1-2@m">
              <div className=' uk-text-left'>
                <a href="/#" className='uk-text-bold'>
                  <img src={Image.WHITE_LOGO} alt="Logo" width='280px' />
                </a>
                <p className='uk-text-left uk-text-justify text-white'>
                  Our mission was to revolutionize the logistics industry through innovation and an unwavering commitment to customer satisfaction. Utilizing our proprietary logistics operating system, we ensure the highest level of security and efficiency, providing our customers with peace of mind knowing their shipments are always safe and secure.
                </p>
                {/* <a href=`${process.env.REACT_APP_API_URL}/` target='_blanks' className='rcl-link' onClick={scrollToTop} ><p className='text-primary'>RCL</p></a> */}
              </div>
            </div>
            <div className="uk-width-1-4@m">
              <div className='uk-text-left'>
                <ul style={{ listStyleType: 'none' }} className=''>
                  <h3 className='uk-text-bold text-white'>
                    Quick link
                  </h3>
                  <li className='foot-link'>
                    <Link to="/track" onClick={scrollToTop} className="uk-text-capitalize text-white link">Track</Link>
                  </li>
                  <li className='foot-link'>
                    <Link to="/service" onClick={scrollToTop} className="uk-text-capitalize text-white link">Service</Link>
                  </li>
                  <li className='foot-link'>
                    <Link to="/Privacy" onClick={scrollToTop} className="uk-text-capitalize text-white link">privacy policy</Link>
                  </li>
                  <li className='foot-link'>
                    {/* <a href="https://onlinebooking.mystratos.co.in" onClick={scrollToTop} className="uk-text-capitalize text-white link">Book a Shipment</a> */}
                    <Link to="/contact" onClick={scrollToTop} className="uk-text-capitalize text-white link">Book a Shipment</Link>
                  </li>
                  <li className='foot-link'>
                    <Link to="/term" onClick={scrollToTop} className="uk-text-capitalize text-white link">Terms & Conditions</Link>
                  </li>

                  <li className='foot-link'>
                    <Link to="/Returnpolicy" onClick={scrollToTop} className="uk-text-capitalize text-white link">refund & return policy</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="uk-width-1-4@m">
              <div className='uk-text-left'>
                <h3 className='text-white uk-text-bold uk-margin-remove'>
                  Location
                </h3>
                {/* <h4 className="text-white uk-margin-small uk-text-bold">Delhi</h4>
                <p className='text-white'>
                  <a rel="noreferrer" href='https://maps.app.goo.gl/2hHV2HnEB5UeQLvV7' target='_blank' className='text-white footer-link'>A-102, Mahipalpur, New Delhi -110037.</a>
                </p> */}
                <h4 className='text-white uk-margin-small uk-text-bold'>Tiruppur</h4>
                <p className='text-white uk-margin-small'>
                  <a rel="noreferrer" href='https://maps.app.goo.gl/CeJJU32GYDZUYrzC7' target='_blank' className='text-white footer-link'>14A-5, Tiruppur Road, Rayarpalayam, Palladam-641664.</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <p className='uk-text-center text-white uk-margin-small-bottom uk-text-uppercase' style={{ fontSize: '12px', letterSpacing: '1px', fontWeight: '600' }}>
          STRATOS reserves the rights.
        </p>
      </div>
    </div>
  )
}

export default Footer